module.exports = __webpack_public_path__ + "cement/img/组 129@2x.d369fa36.png";